import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  addDoc,
  setDoc,
  deleteDoc,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { database } from "../../firebase";
import { serializeFirebaseData } from "../../utils/serializeFirebaseData";

const collectionName = "appointments";
const collectionNameTwo = "timeslot";

export const fetchAppointments = createAsyncThunk(
  "appointments/fetchAppointments",
  async (_, { rejectWithValue }) => {
    try {
      const querySnapshot = await getDocs(collection(database, collectionName));
      const appointments = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...serializeFirebaseData(doc.data()),
      }));
      return appointments;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addAppointment = createAsyncThunk(
  "appointments/addAppointment",
  async (newAppointment, { rejectWithValue }) => {
    try {
      const docRef = await addDoc(
        collection(database, collectionName),
        newAppointment
      );

      if (newAppointment.timeslot) {
        const timeslotRef = doc(
          database,
          collectionNameTwo,
          newAppointment.timeslot
        );
        await updateDoc(timeslotRef, {
          appointment: arrayUnion(docRef.id),
        });
      }

      return {
        appointmentId: docRef.id,
        newAppointment: newAppointment,
        updatedTimeslotId: newAppointment.timeslot,
      };
    } catch (error) {
      return rejectWithValue(`[${error.code || error.name}] ${error.message}`);
    }
  }
);

export const updateAppointment = createAsyncThunk(
  "appointments/updateAppointment",
  async ({ id, updatedData }, { rejectWithValue }) => {
    if (!id || id === "undefined" || id === "null") {
      return rejectWithValue(`Invalid appointmentId: "${id}"`);
    }

    try {
      const appointmentRef = doc(database, collectionName, id);
      await updateDoc(appointmentRef, updatedData);
      return { id, updatedData };
    } catch (error) {
      return rejectWithValue(`[${error.code || error.name}] ${error.message}`);
    }
  }
);

export const deleteAppointment = createAsyncThunk(
  "appointments/deleteAppointment",
  async (id, { rejectWithValue }) => {
    try {
      const appointmentRef = doc(database, collectionName, id);
      const appointmentSnapshot = await getDocs(
        collection(database, collectionName)
      );
      const appointmentData = appointmentSnapshot.docs
        .find((doc) => doc.id === id)
        ?.data();

      if (!appointmentData) {
        throw new Error("Appointment not found");
      }

      if (appointmentData.timeslot) {
        const timeslotRef = doc(
          database,
          collectionNameTwo,
          appointmentData.timeslot
        );
        await updateDoc(timeslotRef, {
          appointment: arrayRemove(id),
        });
      }

      await deleteDoc(appointmentRef);

      return {
        id,
        timeslotId: appointmentData.timeslot || null,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
